export const formatCurrency = (value) => {
  if (value === 0 || value === undefined || value === null) return '$0.00';

  const numValue = typeof value === 'string' ? parseFloat(value) : Number(value);

  if (!Number.isFinite(numValue)) return '$0.00';

  const isNegative = numValue < 0;
  const absValue = Math.abs(numValue);
  const formatted = '$' + absValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return isNegative ? `-${formatted}` : formatted;
};

export const formatDate = (dateString) => {
  if (!dateString) return '';

  const parts = dateString.split(/[-/]/);

  if (parts.length === 3) {
    let year;
    let month;
    let day;

    if (parts[0].length === 4) {
      year = parseInt(parts[0], 10);
      month = parseInt(parts[1], 10) - 1;
      day = parseInt(parts[2], 10);
    } else {
      month = parseInt(parts[0], 10) - 1;
      day = parseInt(parts[1], 10);
      year = parseInt(parts[2], 10);
    }

    const date = new Date(year, month, day);

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  const date = new Date(dateString);

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};